__webpack_public_path__ = window.publicPath;  // eslint-disable-line no-undef

import App from 'Components/App.vue';
import appFactory from 'Libs/appFactory';
import { initCsrf } from 'Libs/helpers/csrf';

const initialState = window.__INITIAL_STATE__;
initCsrf(initialState.csrfToken);
const { app } = appFactory(App, initialState);

app.$mount('#app', true);
